import React from 'react';
import { Github, Linkedin, Mail, ArrowUp } from 'lucide-react';
import { personalInfo } from '../data/mock';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#232323] text-white py-16">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          {/* Logo & Copyright */}
          <div>
            <a href="#" className="header-logo text-white inline-block mb-4">
              KB<span className="text-[#38FF62]">.</span>
            </a>
            <p className="font-body text-[rgba(255,255,255,0.5)] text-sm">
              © {currentYear} Krishnanshu Bhadauria. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 border border-[rgba(255,255,255,0.2)] hover:bg-[#38FF62] hover:border-[#38FF62] group transition-all"
            >
              <Github className="w-5 h-5 group-hover:text-[#232323] transition-colors" />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 border border-[rgba(255,255,255,0.2)] hover:bg-[#38FF62] hover:border-[#38FF62] group transition-all"
            >
              <Linkedin className="w-5 h-5 group-hover:text-[#232323] transition-colors" />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="p-3 border border-[rgba(255,255,255,0.2)] hover:bg-[#38FF62] hover:border-[#38FF62] group transition-all"
            >
              <Mail className="w-5 h-5 group-hover:text-[#232323] transition-colors" />
            </a>
          </div>

          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="p-3 bg-[#38FF62] hover:bg-[#2AE052] transition-colors self-start lg:self-auto"
          >
            <ArrowUp className="w-5 h-5 text-[#232323]" />
          </button>
        </div>

        {/* Bottom Credits */}
        <div className="mt-12 pt-8 border-t border-[rgba(255,255,255,0.1)]">
          <p className="font-mono text-xs text-[rgba(255,255,255,0.4)] uppercase tracking-wider text-center">
            Designed & Built with passion
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;